import React from "react";
import PathOption from "../PathOption";
import PathOptionGroup from "../PathOptionGroup";

function PathBuilderOptionsKeyBackup({ t, options, handleOptionChange, osSelected }) {
  return (
    <PathOptionGroup title={t("pathBuilder.categories.keyBackup")}>
      <PathOption
        id="backup-seed-seedor"
        label={t("pathBuilder.checkboxes.backupSeedSeedor")}
        checked={options.backupSeedSeedor}
        onChange={() => handleOptionChange("backupSeedSeedor")}
        disabled={!osSelected}
      />
    </PathOptionGroup>
  );
}

export default PathBuilderOptionsKeyBackup;
